import PropTypes from 'prop-types';
import React from 'react';

import { cymbioColors } from '../../../utils/colors';

const strokeColor = cymbioColors.analytics.darkGray;

export function ReportsOrdersIcon({ color = strokeColor }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_967)">
        <path
          d="M10.0007 17.5L3.33398 13.75V6.25L10.0007 2.5L16.6673 6.25V10"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10 10L16.6667 6.25" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 10V17.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0007 10L3.33398 6.25" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5 15H18.3333" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.834 12.5L18.334 15L15.834 17.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1_967">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

ReportsOrdersIcon.propTypes = {
  color: PropTypes.string,
};
